// Load Styles
import "../../../scss/web/shared/style.scss";

// Load Icon Fonts init
import "@fortawesome/fontawesome-free/js/all.js";

// Load Bootstrap init
import "bootstrap";
import {
  ScrollToTop,
  Search,
  MobileMenuButton,
  Breakpoints,
  StickyHeader,
  Loader,
} from "../components/index.js";

class App {
  constructor() {}

  init() {
    console.log(`Author: ${process.env.AUTHOR}`);

    const scrollToTop = new ScrollToTop();
    const search = new Search();
    const mobileMenuButton = new MobileMenuButton();
    const breakpoints = new Breakpoints();
    const stickyHeader = new StickyHeader();
    const loader = new Loader("#global-loader", { showOnLoad: false });

    search.init();
    mobileMenuButton.init();
    breakpoints.init();
    scrollToTop.init();
    stickyHeader.init();
    loader.hide();
  }

  focus() {
    setTimeout(() => {
      document.querySelectorAll("section input,select,textarea")[0].focus();
    }, 250);
  }

  showLoader() {
    const loader = new Loader("#global-loader", { showOnLoad: true });
    loader.show();
  }

  hideLoader() {
    const loader = new Loader("#global-loader", { showOnLoad: false });
    loader.hide();
  }

  createError(key) {
    let input = document.getElementById(key);

    if (input.getAttribute("data-target") != null) {
      let target = input.getAttribute("data-target");
      input = document.getElementById(target);
    }

    input.classList.add("is-invalid");
  }
}

export default App;
